import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 124px;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media screen and (min-width: 768px) {
    gap: 24px;
  }
`;

export const Title = styled.h3`
  color: #292929;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 2px;
`;
